module.exports = __webpack_public_path__ + "static/media/timesheet-icon.fe76fe84.svg";